import { gql } from "../generated-graphql";

const GET_DOCUMENT_DOWNLOAD_LINK_QUERY = gql(`
  query GetDocumentDownloadLink($id: ID!, $inline: Boolean) {
    getDocumentDownloadLink(id: $id, inline: $inline)
  }
`);

export default GET_DOCUMENT_DOWNLOAD_LINK_QUERY;
